export default "__VITE_ASSET__CCd9ZhZo__";